import { render } from "./barcodeComponent.vue?vue&type=template&id=3364e99d&scoped=true"
import script from "./barcodeComponent.vue?vue&type=script&lang=js"
export * from "./barcodeComponent.vue?vue&type=script&lang=js"

import "./barcodeComponent.vue?vue&type=style&index=0&id=3364e99d&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3364e99d"]])

export default __exports__